import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class LanguageService {
  private langSelectedSubject = new BehaviorSubject<string>(null);
  private getLangObservable: Observable<any> = this.langSelectedSubject.asObservable();

  setLang(dataTest) {
    this.langSelectedSubject.next(dataTest);
  }

  returnLang(): Observable<[]> {
    return this.getLangObservable;
  }
}
